import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { employeeTaskFilteringSchema } from '../employeeTaskFilteringSchema';
import { EmployeeTaskDetailsListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import TextField from '@material-ui/core/TextField';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'EMPLOYEETASKDETAILS'

export function EmployeeTaskDetailsFiltering(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Employee Task Details");
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [employee, setEmployee] = useState([]);
    const [employeeTaskDetailsFilteringData, setEmployeeTaskDetailsFilteringData] = useState([]);
    const [employeeTaskDetailsFiltering, setEmployeeTaskDetailsFiltering] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        date: "",
        employeeID: "0",
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
     });

    const schema = Joi.object(employeeTaskFilteringSchema).options({ allowUnknown: true });
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [searchData, setSearchData] = useState([]); 

    useEffect(() => {
        trackPromise(
            getGroupsForDropdown()
        )
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntityForDropdown()
        )
    }, [employeeTaskDetailsFiltering.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointForDropDown()
        )
    }, [employeeTaskDetailsFiltering.operationEntityID]);

    useEffect(() => {
        trackPromise(
            getEmployeeForDropDown()
        )
    }, [employeeTaskDetailsFiltering.collectionPointID]);

     async function getPermissions() {
      var permissions = await authService.getPermissionsByScreen(screenCode);

         var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEETASKDETAILlISTING');

     if(isAuthorized === undefined){
        props.history.push('/unauthorized');
     }

     var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
     var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

     setPermissions({
     ...permissionList,
     isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
     isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
     
      });

     var token = tokenService.getUserDetailsFromToken();
      setEmployeeTaskDetailsFiltering({
      ...employeeTaskDetailsFiltering,
     groupID: token.groupID,
     operationEntityID: token.operationEntityID,
     });

     getGroupsForDropdown();
     }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntityForDropdown() {
        const operationEntity = await services.getOperationEntityForDropdown(employeeTaskDetailsFiltering.groupID);
        setOperationEntity(operationEntity);

    }

    async function getCollectionPointForDropDown() {
        const collectionPoint = await services.getCollectionPointForDropDown(employeeTaskDetailsFiltering);
        setCollectionPoint(collectionPoint);
    }

    async function getEmployeeForDropDown() {
            const employee = await services.getEmployeeForDropDown(employeeTaskDetailsFiltering.collectionPointID);
            setEmployee(employee);
    }
    function handleGroupChange(target){
        validateInputs(target);

        setEmployeeTaskDetailsFiltering({
            ...employeeTaskDetailsFiltering,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID: '0',
            date: "",
            employeeID: '0',
        })
    }

    function handleOperationEntityChange(target){
        validateInputs(target);

        setEmployeeTaskDetailsFiltering({
            ...employeeTaskDetailsFiltering,
            operationEntityID: target.value,
            collectionPointID: '0',
            date: "",
            employeeID: '0',
        })
    }

    function handleCollectionPointChange(target){
        validateInputs(target);

        setEmployeeTaskDetailsFiltering({
            ...employeeTaskDetailsFiltering,
            collectionPointID: target.value
        })
    }

    function handleDateChange(target){
        validateInputs(target);

        setEmployeeTaskDetailsFiltering({
            ...employeeTaskDetailsFiltering,
            date: target.value
        })
    }

    function handleEmployeeIDChange(target){
        validateInputs(target);

        setEmployeeTaskDetailsFiltering({
            ...employeeTaskDetailsFiltering,
            employeeID: target.value,
        })
    }

    function validateInputs(target){
        const error = {...errors};
        const errorMessage = validateProperty(target, employeeTaskFilteringSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
        

    }

   async function handleSearch(e) {
        if (e !== undefined) {
            e.preventDefault();
        }

        const errorMessages = validate(schema, employeeTaskDetailsFiltering);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const response = await services.getEmployeeTaskFilterData(employeeTaskDetailsFiltering);

        if (response.length > 0) {
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }

        createSearchData();
        setEmployeeTaskDetailsFilteringData(response); 
    }

    function createSearchData() {
        setSearchData({
            group: groups[employeeTaskDetailsFiltering.groupID],
            operationEntity: operationEntity[employeeTaskDetailsFiltering.operationEntityID],
            collectionPoint: collectionPoint[employeeTaskDetailsFiltering.collectionPointID],
            date: employeeTaskDetailsFiltering.date,
            employee: employee[employeeTaskDetailsFiltering.groupID],
        });
    }

    function clearState() {
        setEmployeeTaskDetailsFiltering({
            ...employeeTaskDetailsFiltering,
            collectionPointID: '0',
            date: "",
            employeeID: '0',
        });
        setEmployeeTaskDetailsFilteringData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => trackPromise(handleSearch(e))} 
                            disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={employeeTaskDetailsFiltering.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={employeeTaskDetailsFiltering.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={employeeTaskDetailsFiltering.collectionPointID}
                                            onChange={(e) => handleCollectionPointChange(e.target)}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText error>{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                
                                
                                    <div className="col-md pb-1">
                                        <TextField
                                            id="date"
                                            label="Date *"
                                            name="date"
                                            type="date"
                                            fullWidth
                                            onChange={(e) => handleDateChange(e.target)}
                                            InputLabelProps={{
                                            shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6 pb-1">
                                        <InputLabel shrink id="employeeID">Employee Name</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="employeeID"
                                            id="employeeID"
                                            name="employeeID"
                                            value={employeeTaskDetailsFiltering.employeeID}
                                            onChange={(e) => handleEmployeeIDChange(e.target)}>
                                            <MenuItem value="0">--Select Employee--</MenuItem>
                                            {generateDropDownMenu(employee)}
                                        </Select>
                                        {errors["employeeID"] && <FormHelperText error>{errors["employeeID"]}</FormHelperText>}
                                    </div>

                                </div>
                                <div className="card-footer">
                                    <input
                                        type="submit"
                                        className="btn btn-primary"                                       
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                                <EmployeeTaskDetailsListing employeeTaskDetailsFilteringData={employeeTaskDetailsFilteringData} 
                                isDataAvilable={isReportButtonsEnabled} searchData={searchData}/>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}